export default [
  {
    path: "/data-pelanggan",
    component: () => import("@/pages/customers/customer-list.vue"),
    meta: {
      requiredLevel: ["admin", "loket", "kelurahan", "penagih", "satgas"],
    },
  },
  {
    path: "/data-pelanggan/create",
    component: () => import("@/pages/customers/customer-form.vue"),
    meta: {
      requiredLevel: ["admin", "loket", "kelurahan", "penagih", "satgas"],
    },
  },
  {
    path: "/data-pelanggan/update/:id",
    component: () => import("@/pages/customers/customer-update.vue"),
    meta: {
      requiredLevel: ["admin", "loket", "kelurahan", "penagih", "satgas"],
    },
  },
  {
    path: "/data-pelanggan/detail/:id",
    component: () => import("@/pages/customers/customer-detail.vue"),
    meta: {
      requiredLevel: ["admin", "loket", "kelurahan", "penagih", "satgas"],
    },
  },
];
